var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLightMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 449,
    zoomAndPan: "magnify",
    viewBox: "0 0 336.75 159.000002",
    height: 212,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "5be122f6e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.929688 0 L 335.574219 0 L 335.574219 158.007812 L 0.929688 158.007812 Z M 0.929688 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 566851200000
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 220,
    y: 0,
    height: 80
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c7fded016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.929688 33.070312 L 79.1875 33.070312 L 79.1875 111.328125 L 0.929688 111.328125 Z M 0.929688 33.070312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "970cc5fcc2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.929688 33.070312 L 70 33.070312 L 70 111.328125 L 0.929688 111.328125 Z M 0.929688 33.070312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d9e42790a5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 33.070312 L 79.1875 33.070312 L 79.1875 111.328125 L 10 111.328125 Z M 10 33.070312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "92671c14bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.203125 41.722656 L 72.996094 41.722656 L 72.996094 105.363281 L 6.203125 105.363281 Z M 6.203125 41.722656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7afd182293"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.203125 0.722656 L 66.996094 0.722656 L 66.996094 64.363281 L 0.203125 64.363281 Z M 0.203125 0.722656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a34bafc4f6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 67,
    y: 0,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "96c1a66611"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.121094 43.738281 L 55.421875 43.738281 L 55.421875 100.378906 L 24.121094 100.378906 Z M 24.121094 43.738281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5be122f6e6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.929688 0 L 335.574219 0 L 335.574219 158.007812 L 0.929688 158.007812 Z M 0.929688 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 89, 39)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5668512e05)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#49aa27",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.736246, 60.287819)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.609375 -56.734375 L 18.5625 -56.734375 L 18.5625 -13.03125 L 38.515625 -13.03125 L 38.515625 0 L 3.609375 0 Z M 3.609375 -56.734375 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#49aa27",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.930794, 60.287819)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.5625 0 L 3.5625 -35.296875 L 18.734375 -35.296875 L 18.734375 0 Z M 11.34375 -40.703125 C 9.019531 -40.703125 7.050781 -41.519531 5.4375 -43.15625 C 3.820312 -44.789062 3.015625 -46.738281 3.015625 -49 C 3.015625 -51.257812 3.820312 -53.222656 5.4375 -54.890625 C 7.050781 -56.554688 9.019531 -57.390625 11.34375 -57.390625 C 12.863281 -57.390625 14.253906 -57.007812 15.515625 -56.25 C 16.773438 -55.488281 17.789062 -54.476562 18.5625 -53.21875 C 19.34375 -51.957031 19.734375 -50.550781 19.734375 -49 C 19.734375 -46.738281 18.90625 -44.789062 17.25 -43.15625 C 15.601562 -41.519531 13.632812 -40.703125 11.34375 -40.703125 Z M 11.34375 -40.703125 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#49aa27",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.483642, 60.287819)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 29.265625 -36.328125 C 31.816406 -36.328125 34.296875 -35.820312 36.703125 -34.8125 C 39.109375 -33.8125 41.09375 -32.207031 42.65625 -30 C 44.21875 -27.789062 45 -24.910156 45 -21.359375 L 45 0 L 29.75 0 L 29.75 -18.90625 C 29.75 -21.0625 29.234375 -22.71875 28.203125 -23.875 C 27.171875 -25.039062 25.796875 -25.625 24.078125 -25.625 C 22.953125 -25.625 21.898438 -25.335938 20.921875 -24.765625 C 19.953125 -24.191406 19.171875 -23.382812 18.578125 -22.34375 C 17.992188 -21.3125 17.703125 -20.109375 17.703125 -18.734375 L 17.703125 0 L 2.5 0 L 2.5 -35.296875 L 17.703125 -35.296875 L 17.703125 -30.515625 C 18.078125 -31.460938 18.804688 -32.375 19.890625 -33.25 C 20.984375 -34.125 22.347656 -34.851562 23.984375 -35.4375 C 25.617188 -36.03125 27.378906 -36.328125 29.265625 -36.328125 Z M 29.265625 -36.328125 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#49aa27",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.964685, 60.287819)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 28.328125 -35.296875 L 45.3125 -35.296875 L 29.234375 -18.4375 L 47.203125 0 L 29.78125 0 L 17.234375 -13.625 L 17.234375 0 L 2.015625 0 L 2.015625 -59.140625 L 17.234375 -59.140625 L 17.234375 -23.6875 Z M 28.328125 -35.296875 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.72877, 60.287819)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.5625 0 L 3.5625 -35.296875 L 18.734375 -35.296875 L 18.734375 0 Z M 11.34375 -40.703125 C 9.019531 -40.703125 7.050781 -41.519531 5.4375 -43.15625 C 3.820312 -44.789062 3.015625 -46.738281 3.015625 -49 C 3.015625 -51.257812 3.820312 -53.222656 5.4375 -54.890625 C 7.050781 -56.554688 9.019531 -57.390625 11.34375 -57.390625 C 12.863281 -57.390625 14.253906 -57.007812 15.515625 -56.25 C 16.773438 -55.488281 17.789062 -54.476562 18.5625 -53.21875 C 19.34375 -51.957031 19.734375 -50.550781 19.734375 -49 C 19.734375 -46.738281 18.90625 -44.789062 17.25 -43.15625 C 15.601562 -41.519531 13.632812 -40.703125 11.34375 -40.703125 Z M 11.34375 -40.703125 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.281617, 60.287819)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.265625 -35.296875 L 5.9375 -35.296875 L 5.9375 -49.78125 L 20.96875 -49.78125 L 20.96875 -35.296875 L 28.453125 -35.296875 L 28.453125 -22.875 L 20.96875 -22.875 L 20.96875 -15.984375 C 20.96875 -14.753906 21.132812 -13.703125 21.46875 -12.828125 C 21.800781 -11.953125 22.507812 -11.515625 23.59375 -11.515625 C 24.257812 -11.515625 24.847656 -11.664062 25.359375 -11.96875 C 25.878906 -12.269531 26.195312 -12.476562 26.3125 -12.59375 L 31.375 -1.84375 C 31.144531 -1.675781 30.445312 -1.351562 29.28125 -0.875 C 28.125 -0.40625 26.664062 0.0234375 24.90625 0.421875 C 23.144531 0.828125 21.191406 1.03125 19.046875 1.03125 C 15.234375 1.03125 12.09375 -0.0195312 9.625 -2.125 C 7.164062 -4.226562 5.9375 -7.472656 5.9375 -11.859375 L 5.9375 -22.875 L 0.265625 -22.875 Z M 0.265625 -35.296875 "
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c7fded016)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#49aa27",
    d: "M 63.058594 111.328125 L 17.054688 111.328125 C 8.148438 111.328125 0.929688 104.109375 0.929688 95.203125 L 0.929688 49.195312 C 0.929688 40.289062 8.148438 33.070312 17.054688 33.070312 L 63.058594 33.070312 C 71.964844 33.070312 79.1875 40.289062 79.1875 49.195312 L 79.1875 95.203125 C 79.1875 104.109375 71.964844 111.328125 63.058594 111.328125 Z M 63.058594 111.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#970cc5fcc2)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.208077, 0, 0, 0.208077, 0.928123, 33.070722)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 129.297769 68.200655 L 85.800527 148.699651 L 42.39715 229.104783 C 38.492348 236.20101 43.298258 245.193318 50.995224 245.193318 L 109.999036 245.193318 L 109.999036 301.606445 C 109.999036 307.895429 115.105315 313.095574 121.506938 313.095574 L 153.796648 313.095574 C 160.104405 313.095574 165.30455 308.008067 165.30455 301.606445 L 165.30455 245.193318 L 147.995764 245.193318 C 140.298798 245.193318 135.492888 236.20101 139.39769 229.104783 L 182.801067 148.699651 L 186.499365 141.903794 L 146.700421 68.200655 C 142.701753 61.104428 133.108706 61.104428 129.297769 68.200655 Z M 129.297769 68.200655 ",
    stroke: "#f3f6f6",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d9e42790a5)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.208077, 0, 0, 0.208077, 0.928123, 33.070722)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 330.301211 229.198648 L 286.897834 148.793517 L 243.400592 68.29452 C 239.608428 61.198293 229.996608 61.198293 226.091805 68.29452 L 186.4055 141.997659 L 190.103798 148.793517 L 233.507175 229.198648 C 237.393204 236.294875 232.606067 245.305957 224.909101 245.305957 L 206.999576 245.305957 L 206.999576 301.70031 C 206.999576 308.008067 212.105856 313.208212 218.507478 313.208212 L 250.797188 313.208212 C 257.104945 313.208212 262.30509 308.101933 262.30509 301.70031 L 262.30509 245.305957 L 321.890868 245.305957 C 329.400103 245.305957 334.206013 236.294875 330.301211 229.198648 Z M 330.301211 229.198648 ",
    stroke: "#f3f6f6",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#92671c14bb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 6, 41)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a34bafc4f6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7afd182293)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#49aa27",
    d: "M 0.203125 0.722656 L 67.074219 0.722656 L 67.074219 64.363281 L 0.203125 64.363281 Z M 0.203125 0.722656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#96c1a66611)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 55.054688 79.117188 L 55.054688 54.433594 L 39.597656 43.738281 L 24.136719 54.433594 L 24.136719 79.117188 L 38.433594 89.011719 L 38.433594 98.347656 L 31.738281 98.347656 L 31.738281 100.671875 L 47.445312 100.671875 L 47.445312 98.347656 L 40.753906 98.347656 L 40.753906 89.011719 Z M 40.761719 86.1875 L 40.761719 80.046875 L 52.730469 71.128906 L 52.730469 77.902344 Z M 40.761719 47.367188 L 48.949219 53.039062 L 40.761719 59.132812 Z M 52.730469 68.230469 L 40.761719 77.148438 L 40.761719 62.035156 L 50.96875 54.433594 L 52.730469 55.652344 Z M 38.4375 47.367188 L 38.4375 68.140625 L 26.464844 59.226562 L 26.464844 55.648438 Z M 26.464844 77.902344 L 26.464844 62.125 L 38.4375 71.042969 L 38.4375 86.191406 Z M 26.464844 77.902344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightMode);
export default __webpack_public_path__ + "static/media/logo_light_mode.6e163ef28fb5f9485e3a689c76a73050.svg";
export { ForwardRef as ReactComponent };